import React from "react";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
//import options from "../../../richText/richTextOptions";
import styled from "styled-components";
import { Container, Row, Col } from "react-bootstrap";
import Img from "gatsby-image";
import Theme from "../../../vars/ThemeOptions";
import CurveBottom from "./CurveAI";
import { H3, P, Button } from "../../common";

const Styled = {};
Styled.SideBySide = styled(Container)`
  p > a {
    color: ${Theme.hex("white")};
    text-decoration: underline;
    opacity: 1;
    transition: all 0.4s ease;
    :hover {
      opactiy: 0.75;
      transition: all 0.4s ease;
    }
  }
  .hero {
    & > .col {
      min-width: 50%;
      padding: 0;
    }
    .text-col {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0;
    }
  }
  .contained {
    margin-bottom: 10vh;
    & > .col {
      //position: relative;
      padding: 0;
      min-width: 50%;
    }
    .copy-div {
      padding: 0;
    }
  }
  .fluid {
    position: relative;
    & > .col {
      padding: 0;
      .gatsby-image-wrapper {
        height: 60vh !important;
      }
    }
  }
  .curved {
    min-height: 70vh;
    & > .col {
      padding: 0;
    }
    .gatsby-image-wrapper {
      min-height: 70vh;
    }
    .text-col {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .overlay {
    background: rgba(0, 0, 0, 0.5);
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    @media screen and (max-width: ${Theme.break.sm}px) {
      background: rgba(0, 0, 0, 0.65) !important;
    }
  }
  .contained,
  .hero {
    & > .col {
      .gatsby-image-wrapper {
        //width: 100% !important;
        height: calc(100% + 30px);
        bottom: 30px;
        @media screen and (max-width: ${Theme.break.sm}px) {
          //height: 50vh !important;
          min-height: 40vh;
          top: 30px;
        }
      }
    }
  }
`;

export const SideBySide = ({ topic }) => {
  const {
    mainImage,
    squareImage,
    title,
    slug,
    jumpText,
    ctaLayout,
    chapter,
  } = topic;
  //console.log(topic);
  const { fluid } = mainImage ? mainImage : { fluid: null };
  const { fixed } = squareImage ? squareImage : { fixed: null };
  const { json } = jumpText ? jumpText : { json: null };
  const type = ctaLayout.toLowerCase();
  const path = `/` + chapter.toLowerCase() + `/` + slug;
  const isFluid = type === "curved" || type === "fluid";
  const isContained = ctaLayout === "Contained";

  return (
    <Styled.SideBySide fluid={isContained ? false : true}>
      <Row
        className={type}
        style={{ position: "relative", overflow: "hidden" }}
      >
        <>
          <Col
            style={{
              position: isFluid ? "absolute" : "relative",
            }}
          >
            <Img
              fluid={isFluid ? fluid : undefined}
              fixed={!isFluid && fixed ? fixed : undefined}
              alt={mainImage.title}
              style={{
                height: isFluid ? `50vh` : undefined,
                width: "100%",
              }}
            />
          </Col>
          {isFluid ? (
            <div
              className="overlay"
              style={
                type === "fluid"
                  ? {
                      background: `linear-gradient(
                90deg,
                rgba(0, 0, 0, 1) 0%, 
                rgba(0, 0, 0, 0) 70%)`,
                    }
                  : {
                      background: `linear-gradient(
                      -90deg,
                      rgba(0, 0, 0, 1) 0%, 
                      rgba(0, 0, 0, 0) 70%)`,
                    }
              }
            />
          ) : null}
        </>

        <Col
          sm={12}
          md={type === "curved" ? { span: 6, offset: 6 } : 6}
          className="text-col content-col"
          style={
            ctaLayout === "Hero" || ctaLayout === "Contained"
              ? { background: Theme.hex("blue"), color: Theme.hex("white") }
              : {}
          }
        >
          <div className="copy-div" style={{ padding: "12vh 8vh" }}>
            {title && (
              <H3
                style={
                  ctaLayout === "Curved" ? { color: Theme.hex("black") } : {}
                }
                white={isFluid ? true : undefined}
              >
                {title}
              </H3>
            )}
            {json && (
              <P
                className="copy"
                style={
                  ctaLayout === "Curved" ? { color: Theme.hex("blue") } : {}
                }
                white={isFluid ? true : undefined}
              >
                {documentToReactComponents(json)}
              </P>
            )}
            {slug && (
              <Button
                white={
                  type === "hero" || type === "contained" ? true : undefined
                }
                to={path}
              >
                Learn More
              </Button>
            )}
          </div>
        </Col>
        <Col sm={12} md={6} className="content-col" />
        {ctaLayout === "Curved" ? <CurveBottom /> : null}
      </Row>
    </Styled.SideBySide>
  );
};
